/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_CompareInputs */

const en_admin_funnel_footnote_compare = /** @type {(inputs: Admin_Funnel_Footnote_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today vs yesterday compares the same clock time: today 00:00 → now against yesterday 00:00 → this time yesterday (UTC+8).`)
};

/**
* | output |
* | --- |
* | "Today vs yesterday compares the same clock time: today 00:00 → now against yesterday 00:00 → this time yesterday (UTC+8)." |
*
* @param {Admin_Funnel_Footnote_CompareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_compare = /** @type {((inputs?: Admin_Funnel_Footnote_CompareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_CompareInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_compare(inputs)
});
export { admin_funnel_footnote_compare as "admin.funnel.footnote.compare" }